module.exports = __webpack_public_path__ + "static/media/ecosystem.9ce09fbb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MailingPage/ecosystem.svg
// module id = 997
// module chunks = 0